module.exports = __webpack_public_path__ + "src/images/css3-logo.cb4f694ce1d08b9953e9edf1059d1013.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/css3-logo.png
// module id = 95
// module chunks = 0